
import { TileMenuItem } from "@/api/dtos";
import Icon from "@/components/layouts/Icon/Icon";
import { faCircleInfo } from "@fortawesome/pro-duotone-svg-icons";
import { Chip, ListItemText, Skeleton, Tooltip, Typography } from "@mui/material";
import React from "react";
import { ChipError, InformationIcon, StyledListItem, StyledListItemButton, StyledListItemIcon, StyledListItemInformationIcon, StyledListItemText } from "..";
import EvaluateColour from "./EvaluateColour";


interface IMenuItemContents {
    menuItem: TileMenuItem;
    tileData?: Record<string, string>;
}

const MenuItemContents: React.FunctionComponent<IMenuItemContents> = ({
    menuItem,
    tileData
}) => { 
    
    return (
        <>

            {
                menuItem.link ? (

                    <StyledListItemButton
                        //@ts-ignore
                        component="a"
                        href={menuItem.link}
                        target={menuItem.linkNewTab === true ? '_blank' : '_self'}
                    >
                        <StyledListItemIcon>
                            <Icon icon={{ prefix: menuItem.iconPrefix as any, iconName: menuItem.iconName as any }} size="lg" fixedWidth />
                        </StyledListItemIcon>
                        
                        {
                            menuItem.tooltipInformations && menuItem.tooltipInformations.length > 0 ? (
                                <>
                                    <StyledListItemText 
                                        primary={menuItem.name}
                                    />
                                    <StyledListItemInformationIcon>
                                        <Tooltip title={menuItem.tooltipInformations.map(
                                            (tooltipInformation, i, entireList) => (
                                                <div key={i}>
                                                    <Typography variant="h4">
                                                        {tooltipInformation.heading}
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {tooltipInformation.content}
                                                    </Typography>
                                                    {
                                                        (i < (entireList.length - 1)) && <br />
                                                    }
                                                </div>
                                            )
                                        )}>
                                            <InformationIcon icon={faCircleInfo} size="lg" fixedWidth />
                                        </Tooltip>
                                    </StyledListItemInformationIcon>
                                </>
                            ) : (
                                <ListItemText 
                                    primary={menuItem.name}
                                />
                            )
                        }
                        {
                            menuItem.dataKey && (
                                <>
                                    {
                                        tileData ? (
                                            <>
                                                {
                                                    (tileData[menuItem.dataKey] === "Error") ? (
                                                        <ChipError label={"Error"} size="small" />
                                                    ) : (
                                                        (tileData[menuItem.dataKey]) ? (
                                                            !!menuItem.dataColoursAndConditions ? (
                                                                <Chip label={tileData[menuItem.dataKey]} size="small" sx={{ backgroundColor: EvaluateColour(menuItem.dataColoursAndConditions, tileData[menuItem.dataKey]) }} />
                                                            ) : (
                                                                <Chip label={tileData[menuItem.dataKey]} size="small" />
                                                            )
                                                        ) : (
                                                            <Skeleton variant='circular' width={16} height={16} />
                                                        )
                                                    )
                                                }
                                            </>
                                        ) : (
                                            <Skeleton variant='circular' width={16} height={16} />
                                        )
                                    }
                                
                                </>
                            )
                        }
                    </StyledListItemButton>

                ) : (

                    <StyledListItem>
                        <StyledListItemIcon>
                            <Icon icon={{ prefix: menuItem.iconPrefix as any, iconName: menuItem.iconName as any }} size="lg" fixedWidth />
                        </StyledListItemIcon>
                        <ListItemText 
                            primary={menuItem.name}
                        />
                        
                        {
                            menuItem.tooltipInformations && menuItem.tooltipInformations.length > 0 && (
                                <StyledListItemIcon>
                                <Tooltip title={menuItem.tooltipInformations.map(
                                    (tooltipInformation, i, entireList) => (
                                        <div key={i}>
                                            <Typography variant="h4">
                                                {tooltipInformation.heading}
                                            </Typography>
                                            <Typography variant="body1">
                                                {tooltipInformation.content}
                                            </Typography>
                                            {
                                                (i < (entireList.length - 1)) && <br />
                                            }
                                        </div>
                                    )
                                )}>
                                        <InformationIcon icon={faCircleInfo} size="lg" fixedWidth />
                                    </Tooltip>
                                </StyledListItemIcon>
                            )
                        }
                        {
                            menuItem.dataKey && (
                                <>
                                    
                                    {
                                        tileData ? (
                                            <>
                                                {
                                                    (tileData[menuItem.dataKey] === "Error") ? (
                                                        <ChipError label={"Error"} size="small" />
                                                    ) : (
                                                        (tileData[menuItem.dataKey]) ? (
                                                            !!menuItem.dataColoursAndConditions ? (
                                                                <Chip label={tileData[menuItem.dataKey]} size="small" sx={{ backgroundColor: EvaluateColour(menuItem.dataColoursAndConditions, tileData[menuItem.dataKey]) }} />
                                                            ) : (
                                                                <Chip label={tileData[menuItem.dataKey]} size="small" />
                                                            )
                                                        ) : (
                                                            <Skeleton variant='circular' width={16} height={16} />
                                                        )
                                                    )
                                                }
                                            </>
                                        ) : (
                                            <Skeleton variant='circular' width={16} height={16} />
                                        )
                                    }
                                    
                                
                                </>
                            )
                        }
                    </StyledListItem>

                )
            }

        </>
    );
}

export default MenuItemContents;